/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_ProcessingInputs */

const vi_einvoice_processing = /** @type {(inputs: Einvoice_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xử lý hoá đơn điện tử...`)
};

/**

* @param {Einvoice_ProcessingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_processing = /** @type {((inputs?: Einvoice_ProcessingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_ProcessingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_processing(inputs)
});